import { Button, Col, Row } from "reactstrap";
import {
  faFile,
  faFileEdit,
  faFilePdf,
  faSearch
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import { useLocation, useNavigate } from "react-router-dom";

//Helpers
import mascaras from "../../../../helpers/mascaras";

//Components
import TabelaListagemFichas from "../../../../components/TabelaListagemFichas/TabelaListagemFichas";
import AlteracaoEmail from "./AlteracaoEmail";
import HistoricoVisualizacoes from "./HistoricoVisualizacoes";
import Anexo from "../../../../components/Anexo";
import { useAuth } from "../../../../context/auth";


function CabecalhoInfracao({
  infracao,
  handleVisualizarFiscalizacao,
  onSubmitAlteracaoEmail,
  infracaoAlteracaoEmail,
  setInfracaoAlteracaoEmail,
  reenviarEmail,
  showDivs,
  historico = false
}) {


  const { session, logoSistema, logoSecretaria, logoPrefeitura } = useAuth();

  const location = useLocation();
  const navigate = useNavigate();

  const headersListaFiscalizacaoInfracaoAlteracaoEmails = [
    { value: "E-mail Antigo", objectValue: "emailAnterior", align: "left" },
    { value: "E-mail Atualizado", objectValue: "emailAtualizado", align: "left" },
    { value: "Usuário", objectValue: "usuario", align: "left" },
    {
      value: "DATA/HORA",
      objectValue: "dataHora",
      formatDate: true,
      align: "left",
    },
  ];

  // Headers para exibição da lista de resets
  const headersListaResets = [
    { value: "Usuário", objectValue: "usuario", align: "left" },
    { value: "Data/Hora", objectValue: "dataHora", formatDate: true, align: "left" },
    { value: "Motivo", objectValue: "motivo", align: "left" },
  ];

  const abrirFichaHistorica = (item) => {
    const resetId = item?.id ?? item?.resetId ?? item?.backupId;
    if (!resetId) return;
    const _location = { ...(location.state || {}) };
    delete _location.btnVoltar;
    navigate("/admin/ficha-infracao-historico", {
      state: {
        ..._location,
        resetId: resetId,
      },
    });
  };

  return (
    <>
      {historico && (
        <div className="alert alert-danger" role="alert">
          Este registro foi resetado e está disponível somente para consulta histórica. Nenhuma ação está disponível nesta ficha.
        </div>
      )}

      <div className="bw-bold d-flex justify-content-center align-items-start flex-column mb-2">
        <div className="d-flex justify-content-between align-items-center w-100">
          {logoSistema && (
            <div>
              <img
                src={logoSistema}
                className="mt-3"
                width={180}
                alt="logo do sistema"
              />
            </div>
          )}
          <div>
            {logoSecretaria && (
              <img
                src={logoSecretaria}
                className="mt-3"
                width={140}
                alt="logo do sistema"
              />
            )}
            {logoPrefeitura && (
              <img
                src={logoPrefeitura}
                className="mt-3"
                width={240}
                alt="logo da prefeitura"
              />
            )}
          </div>
        </div>
        <h2>AUTO DE INFRAÇÃO E SANÇÃO</h2>
        <h5 style={{ color: "#666" }}>
          {infracao?.tipoFiscalizacao_Identificacao}
        </h5>
        <div className="d-flex gap-3">
          <span className="fw-regular">
            <span className="fw-bold">Número da Infração:</span>{" "}
            {infracao?.numeroInfracao}{" "}
          </span>
          <span className="fw-regular">
            <span className="fw-bold">Número da Fiscalização:</span>{" "}
            {infracao?.numeroFiscalizacao}{" "}
          </span>
          <span className="fw-regular">
            <span className="fw-bold">Número do processo interno:</span>{" "}
            {!!infracao?.numeroProcessoInterno
              ? infracao?.numeroProcessoInterno
              : "Não Informado"}
          </span>

          <span className="fw-regular">
            <span className="fw-bold">Data/Hora:</span>{" "}
            {moment(infracao?.dataInfracao).format("DD/MM/YYYY HH:mm:ss")}{" "}
          </span>
        </div>
      </div>
      {!historico &&
        <div className="shadowFicha rounded-3 mt-4">
          <h5 className="titleFicha p-2 d-flex align-items-center justify-content-between">
            Infração e sanção
            {infracao && !showDivs && !historico && (
              <div className="noPrint">
                <Button
                  color="dark"
                  className="text-white p-1 m-0 "
                  style={{ fontSize: "12px" }}
                  onClick={() => handleVisualizarFiscalizacao(infracao)}
                  role="button"
                >
                  <FontAwesomeIcon icon={faFile} /> Auto de Fiscalização
                </Button>
              </div>
            )}
          </h5>
          <Row className="px-3 py-2">
            <Col md="12" lg="8" className="mb-2">
              <span className="fw-bold">Endereço da infração: </span>{" "}
              {infracao?.enderecoCompleto ?? ""}
            </Col>

            <Col md="12" lg="6" className="mb-2">
              <span className="fw-bold">Tipo serviço: </span>{" "}
              {infracao?.tipoFiscalizacaoServico_Identificacao ?? ""}
            </Col>
            <Col md="12" lg="12" className="mb-2">
              <span className="fw-bold">Descrição da Infração: </span>{" "}
              {infracao?.infracao_Identificacao ?? ""}
            </Col>
            <Col md="12" lg="12" className="mb-2">
              <span className="fw-bold">Fundamento Legal: </span>{" "}
              {infracao?.infracao_Clausula ?? ""}
            </Col>
            <Col md="12" lg="4" className="mb-2">
              <span className="fw-bold"> Tipo de Penalidade: </span>{" "}
              {infracao?.tipoInfracao ?? ""}
            </Col>
            <Col md="12" lg="12" className="mb-2">
              <span className="fw-bold">Data da Infração: </span>
              {infracao?.dataFlagrande
                ? moment(infracao?.dataFlagrande).format("DD/MM/YYYY HH:mm")
                : ""}
            </Col>
            <Col md="12" lg="4" className="mb-2">
              <span className="fw-bold">Regional: </span>{" "}
              {infracao?.regional ?? ""}
            </Col>
            <Col md="12" lg="4" className="mb-2">
              <span className="fw-bold">Valor da multa: </span>{" "}
              {infracao?.valor.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </Col>
            <Col md="12" lg="4" className="mb-2">
              <span className="fw-bold">Código do item: </span>{" "}
              {infracao?.fiscalizacaoItem_Codigo}
            </Col>
          </Row>
        </div>
      }
      {!historico &&
        <div className="shadowFicha rounded-3 mt-4">
          <h5 className="titleFicha p-2 d-flex align-items-center justify-content-between">
            Identificação do Infrator

            <div className="d-flex align-items-center justify-content-between gap-2"

            > {session != null &&
              infracao?.permiteAlterarEmail &&
              <AlteracaoEmail
                onSubmitAlteracaoEmail={onSubmitAlteracaoEmail}
                infracaoAlteracaoEmail={infracaoAlteracaoEmail}
                setInfracaoAlteracaoEmail={setInfracaoAlteracaoEmail}
                reenviarEmail={reenviarEmail}
              />
              }
              {session != null &&
                !historico &&
                infracao?.permiteReenvioEmail &&
                (
                  <div className="noPrint">
                    <Button
                      color="dark"
                      className="text-white p-1 m-0 "
                      style={{ fontSize: "12px" }}
                      onClick={() => reenviarEmail()}
                      role="button"
                    >
                      <FontAwesomeIcon icon={faFileEdit} /> Reenviar e-mail
                    </Button>
                  </div>)
              }</div>
          </h5>
          <Row className="px-3 py-2">
            <Col md="12" lg="6" className="mb-2">
              <span className="fw-bold">Nome / Razão social: </span>{" "}
              {infracao?.infrator?.nome ?? ""}
            </Col>
            <Col md="12" lg="6" className="mb-2">
              <span className="fw-bold">Nome Fantasia: </span>{" "}
              {infracao?.infrator?.fantasia ?? ""}
            </Col>
            <Col md="12" lg="6" className="mb-2">
              <span className="fw-bold">CPF/CNPJ: </span>{" "}
              {infracao?.infrator?.documentoIdentificacao ?? ""}
            </Col>
            <Col md="12" lg="6" className="mb-2">
              <span className="fw-bold">Email: </span>{" "}
              {infracao?.infrator?.email ?? ""}
            </Col>
            {
              <Col md="12" lg="6" className="mb-2">
                <span className="fw-bold">Codigo de cadastro: </span>{" "}
                {infracao?.infrator?.codigoCadastro ?? ""}
              </Col>
            }
            {infracao?.infrator?.emailsCC &&
              !!infracao?.infrator?.emailsCC.length > 0 && (
                <Col md="12" lg="12">
                  <span className="fw-bold">Emails CC: </span>{" "}
                  {infracao?.infrator?.emailsCC.join("; ") ?? ""}
                </Col>
              )}
          </Row>

          <Row className="px-3">
            <Col md="12" lg="4" className="mb-2">
              <span className="fw-bold">CEP: </span>{" "}
              {infracao?.infrator?.cep
                ? mascaras.cepMask(infracao?.infrator?.cep)
                : ""}
            </Col>
            <Col md="12" lg="4" className="mb-2">
              <span className="fw-bold">Cidade: </span>{" "}
              {infracao?.infrator?.cidade ?? ""}
            </Col>
            <Col md="12" lg="4" className="mb-2">
              <span className="fw-bold">UF: </span> {infracao?.infrator?.uf ?? ""}
            </Col>
            <Col md="12" lg="4" className="mb-2">
              <span className="fw-bold">Logradouro: </span>{" "}
              {infracao?.infrator?.logradouro ?? ""}
            </Col>
            <Col md="12" lg="4" className="mb-2">
              <span className="fw-bold">Bairro: </span>{" "}
              {infracao?.infrator?.bairro ?? ""}
            </Col>
            <Col md="12" lg="4" className="mb-2">
              <span className="fw-bold">Número: </span>{" "}
              {infracao?.infrator?.numero ?? ""}
            </Col>
            {!!infracao?.infrator?.complemento && (
              <Col md="12" lg="12" className="mb-2">
                <span className="fw-bold">Complemento: </span>{" "}
                {infracao?.infrator?.complemento ?? ""}
              </Col>
            )}

            {infracao?.infrator?.assinaturaInfrator && (
              <>
                <Col md="12" lg="12" className="mb-2">
                  <span className="fw-bold">Assinatura Digital: </span>
                </Col>
                <Col
                  md="12"
                  lg="12"
                  className="mb-2 d-flex justify-content-center"
                >
                  <img
                    width={"300px"}
                    height={"150"}
                    className="text-center"
                    src={
                      "data:image/png;base64," +
                      infracao?.infrator?.assinaturaInfrator
                    }
                  />
                </Col>
              </>
            )}
          </Row>
        </div>
      }

      {session != null && infracao?.fiscalizacaoInfracaoAlteracaoEmails?.length > 0 && (
        <div className="mt-4 shadowFicha rounded-3">
          <h5 className="p-2 titleFicha">Alterações de E-mail</h5>
          <Row className="px-3 py-2">
            <Col md="12" className="mb-2">
              <TabelaListagemFichas
                headers={headersListaFiscalizacaoInfracaoAlteracaoEmails}
                items={infracao?.fiscalizacaoInfracaoAlteracaoEmails}
              />
            </Col>
          </Row>
        </div>
      )}

      <HistoricoVisualizacoes infracao={infracao} showDivs={showDivs} />

      {!historico &&
        <div className="shadowFicha rounded-3 mt-4">
          <h5 className="p-2 titleFicha">Imagens da fiscalização</h5>
          <div className="d-flex gap-3 justify-content-center flex-wrap px-2 py-2">
            {infracao?.anexosSolicitacao?.map((value, key) => {
              return <Anexo key={key} anexo={value?.anexo} label="Imagem da demanda" />
            })}

            {!!infracao?.anexoQuestao && (
              <div className="d-flex flex-column justify-content-center align-items-center">
                {infracao.anexoQuestao.toLowerCase().endsWith(".pdf") ?
                  <Anexo anexo={infracao.anexoQuestao} label="Anexo da fiscalização" /> :
                  <Anexo anexo={infracao.anexoQuestao} label="Imagem da infração" />
                }
              </div>
            )}
          </div>
        </div>
      }

      {!!infracao?.planoTrabalhoLocal &&
        !!infracao?.planoTrabalhoLocal?.latitude &&
        !!infracao?.planoTrabalhoLocal?.longitude && (
          <div className="contentGroup shadowFicha rounded-3 mt-4">
            <h5 className="p-2 titleFicha">Plano de trabalho</h5>
            <Row className="px-3">
              <Col md="12" lg="6" className="mb-2">
                <span className="fw-bold">Identificação: </span>{" "}
                {infracao.planoTrabalhoLocal.identificacao}
              </Col>
              <Col md="12" lg="6" className="mb-2">
                <span className="fw-bold">Endereço da infração: </span>{" "}
                {infracao.planoTrabalhoLocal.enderecoCompleto}
              </Col>
            </Row>
            <div
              style={{ height: "250px", position: "relative" }}
              className="px-3 py-2"
            >
              <MapContainer
                center={[
                  infracao.planoTrabalhoLocal.latitude,
                  infracao.planoTrabalhoLocal.longitude,
                ]}
                style={{ height: "100%", width: "100%" }}
                zoom={20}
              >
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker
                  position={[
                    infracao.planoTrabalhoLocal.latitude,
                    infracao.planoTrabalhoLocal.longitude,
                  ]}
                ></Marker>
              </MapContainer>
            </div>
          </div>
        )}
      {!historico && (
        <div className="mt-4 shadowFicha rounded-3">
          <h5 className="p-2 titleFicha">Identificação do Fiscal</h5>
          <Row className="px-3 py-2">
            <Col md="12" lg="4" className="mb-2">
              <span className="fw-bold">Fiscal: </span>{" "}
              {infracao?.usuario_Nome ?? ""}
            </Col>
            {infracao?.registroFuncional && (
              <Col md="12" lg="4" className="mb-2">
                <span className="fw-bold">Registro Funcional(RF): </span>{" "}
                {infracao?.registroFuncional ?? ""}
              </Col>
            )}
            {infracao?.dataHoraPreenchimento && (
              <Col md="12" lg="4" className="mb-2">
                <span className="fw-bold">Data/Hora Lavratura: </span>{" "}
                {moment(infracao?.dataHoraPreenchimento).format(
                  "DD/MM/YYYY HH:mm:ss"
                )}
              </Col>
            )}
          </Row>
        </div>
      )}
      {infracao?.dadosSolicitacaoFiscalizacaoFalecidos && (
        <>
          <div className="mt-4 shadowFicha rounded-3">
            <h5 className="p-2 titleFicha">
              Dados do Falecido Informados na Solicitação de Vistoria
            </h5>
            <Row className="px-3 py-2">
              <Col md="12" lg="12" className="mb-2">
                <span className="fw-bold"> Nome: </span>{" "}
                {infracao?.dadosSolicitacaoFiscalizacaoFalecidos?.nome ?? ""}
              </Col>
              <Col md="12" lg="6" className="mb-2">
                <span className="fw-bold">Data de Nascimento: </span>{" "}
                {infracao?.dadosSolicitacaoFiscalizacaoFalecidos?.dataNascimento
                  ? moment(
                    infracao?.dadosSolicitacaoFiscalizacaoFalecidos
                      ?.dataNascimento
                  ).format("DD/MM/YYYY")
                  : ""}
              </Col>
              <Col md="12" lg="6" className="mb-2">
                <span className="fw-bold">Data de Falecimento: </span>{" "}
                {infracao?.dadosSolicitacaoFiscalizacaoFalecidos
                  ?.dataFalecimento
                  ? moment(
                    infracao?.dadosSolicitacaoFiscalizacaoFalecidos
                      ?.dataFalecimento
                  ).format("DD/MM/YYYY")
                  : ""}
              </Col>
            </Row>
          </div>
        </>
      )}
      {infracao?.dadosObito && (
        <>
          <div className="mt-4 shadowFicha rounded-3">
            <h5 className="p-2 titleFicha">Dados do Óbito</h5>
            <Row className="px-3 py-2">
              <Col md="12" lg="6" className="mb-2">
                <span className="fw-bold"> Nome: </span>{" "}
                {infracao?.dadosObito?.nome ?? ""}
              </Col>
              <Col md="12" lg="6" className="mb-2">
                <span className="fw-bold">CPF: </span>{" "}
                {infracao?.dadosObito?.cpf
                  ? mascaras.cpfMask(infracao.dadosObito.cpf)
                  : ""}
              </Col>
              <Col md="12" lg="6" className="mb-2">
                <span className="fw-bold">Data de Nascimento: </span>{" "}
                {infracao?.dadosObito?.dataNascimento
                  ? moment(infracao?.dadosObito?.dataNascimento).format(
                    "DD/MM/YYYY"
                  )
                  : ""}
              </Col>
              <Col md="12" lg="6" className="mb-2">
                <span className="fw-bold">Data de Falecimento: </span>{" "}
                {infracao?.dadosObito?.dataFalecimento
                  ? moment(infracao?.dadosObito?.dataFalecimento).format(
                    "DD/MM/YYYY"
                  )
                  : ""}
              </Col>
            </Row>
          </div>
        </>
      )}

      {session != null &&
        !historico &&
        !!infracao && (
          <>
            <div className="mt-4 shadowFicha rounded-3">
              <h5 className="p-2 titleFicha">Dados Administrativos</h5>
              <Row className="px-3 py-2">
                <Col md="12" lg="4" className="mb-2">
                  <span className="fw-bold">Situação: </span>{" "}
                  {infracao?.situacao ?? ""}
                </Col>
                <Col md="12" lg="8" className="mb-2">
                  <span className="fw-bold">Número do processo interno: </span>{" "}
                  {!!infracao?.numeroProcessoInterno
                    ? infracao?.numeroProcessoInterno
                    : "Não Informado"}
                </Col>
                <Col md="12" lg="4" className="mb-2">
                  <span className="fw-bold">Prazo próxima ação: </span>{" "}
                  {infracao?.prazoProximaAcao
                    ? moment(infracao?.prazoProximaAcao).format("DD/MM/YYYY")
                    : ""}
                </Col>
                <Col md="12" lg="4" className="mb-2">
                  <span className="fw-bold">Origem: </span>{" "}
                  {!!infracao?.origem ? infracao?.origem : "Interno"}
                </Col>
              </Row>

              {(() => {
                // Suportar múltiplos resets ou único
                const listaResets = Array.isArray(infracao?.dadosResertaInfracaoList)
                  ? infracao.dadosResertaInfracaoList
                  : (Array.isArray(infracao?.dadosResertaInfracao)
                    ? infracao.dadosResertaInfracao
                    : (infracao?.dadosResertaInfracao ? [infracao.dadosResertaInfracao] : []));

                if (!!listaResets?.length) {
                  return (
                    <>
                      <h5 className="p-2 titleFicha">Dados de Reset da Infração</h5>
                      <Row className="px-3 py-2">
                        <Col md="12" className="mb-2">
                          <TabelaListagemFichas
                            headers={headersListaResets}
                            items={listaResets}
                            visualizar={abrirFichaHistorica}
                          />
                        </Col>
                      </Row>
                    </>
                  );
                }
                return null;
              })()}

              {!!infracao?.dadosResertaInfracao &&
                <>
                  <h5 className="p-2 titleFicha">Dados de Reset da Infração</h5>
                  <Row className="px-3 py-1">
                    <Col md="12" lg="6" className="mb-2">
                      <span className="fw-bold">Nome do Usuário: </span>{" "}
                      {infracao?.dadosResertaInfracao?.usuario ?? ""}
                    </Col>
                    <Col md="12" lg="6" className="mb-2">
                      <span className="fw-bold">Data/Hora: </span>{" "}
                      {!!infracao?.dadosResertaInfracao?.dataHora ? moment(infracao.dadosResertaInfracao.dataHora).format("DD/MM/YYYY HH:mm:ss") : ""}
                    </Col>
                    <Col md="12" lg="12" className="mb-2">
                      <span className="fw-bold">Motivo: </span>{" "}
                      {infracao?.dadosResertaInfracao?.motivo ?? ""}
                    </Col>
                  </Row>
                </>
              }
            </div>

            {infracao.cancelada === true &&
              !!infracao?.dadosCancelamento &&
              <div className="mt-4 shadowFicha rounded-3">
                <h5 className="p-2 titleFicha">Dados do Cancelamento</h5>
                <Row className="px-3 py-2">
                  <Col md="12" lg="6" className="mb-2">
                    <span className="fw-bold">Usuário: </span>{" "}
                    {infracao?.dadosCancelamento?.usuario ?? ""}
                  </Col>
                  <Col md="12" lg="6" className="mb-2">
                    <span className="fw-bold">Data/Hora: </span>{" "}
                    {infracao?.dadosCancelamento?.dataHoraCancelamento
                      ? moment(infracao?.dadosCancelamento?.dataHoraCancelamento).format("DD/MM/YYYY HH:mm:ss")
                      : ""}
                  </Col>
                  <Col md="12" lg="12" className="mb-2">
                    <span className="fw-bold">Justificativa: </span>{" "}
                    {infracao?.dadosCancelamento?.justificativaCancelamento ?? ""}
                  </Col>
                </Row>
              </div>
            }
          </>
        )}
    </>
  );
}

export default CabecalhoInfracao;
